module.exports = __webpack_public_path__ + "img/msp0.c07b7c75.png";